'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/Check.js";
var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? f(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    s.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      h.call(e, r) && m(o, r, e[r]);
  return o;
}, c = (o, e) => i(o, p(e));
const w = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, c(a({ ref: e }, o), { weights: t$1 })));
w.displayName = "Check";
export {
  w as Check
};
